import React, { createContext } from 'react';
import useData from './../Hooks/useData';
import useFormData from './../Hooks/useForm';

export const MainContext = createContext();

const Provider = ({children}) => {
    const data = useData();
    const form = useFormData();
    return (
        <MainContext.Provider value={{data, form}}>
            {children}
        </MainContext.Provider>
    )
}

export default Provider;